import { createFileRoute } from "@tanstack/react-router";

const TARGET = "https://calvarius.com/leistungen/performance-marketing/google-ads";

export const Route = createFileRoute("/adwords-agentur")({
  server: {
    handlers: {
      GET: async () =>
        new Response(null, {
          status: 301,
          headers: { Location: TARGET, "Cache-Control": "public, max-age=3600" },
        }),
    },
  },
  component: () => null,
  beforeLoad: () => {
    if (typeof window !== "undefined") {
      window.location.replace(TARGET);
    }
  },
});
